(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    class VariantCardPicker extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll('.variant-card__input');
      this.cards  = this.querySelectorAll('.variant-card');
    }

    connectedCallback() {
      this.inputs.forEach((input) => {
        input.addEventListener('change', this.onVariantChange.bind(this));
      });
    }

    onVariantChange(event) {
      const selectedVariantId = event.target.value;

      // Instantly highlight the selected card for visual feedback
      this.cards.forEach((card) => {
        const isSelected = card.dataset.variantId === selectedVariantId;
        card.classList.toggle('variant-card--selected', isSelected);
        // Dim all cards while navigating so user knows something is happening
        card.classList.add('variant-card--navigating');
      });

      // Navigate to the variant URL — Horizon re-renders images,
      // price, ATC button, and availability correctly server-side
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariantId);
      window.location.assign(url.toString());
    }
  }

  if (!customElements.get('variant-card-picker')) {
    customElements.define('variant-card-picker', VariantCardPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
